<!-- BaseContainer.vue -->
<template>
  <div class="container custom2">
    <slot />
  </div>
</template>

<style>
/* 
Ideal content width: 700px – 1000px

*/
.custom2 {
   max-width: 900px;
  /*background: lightgrey; 
  border: 2px solid black;*/
}
</style>

